module.exports = __webpack_public_path__ + "static/img/wepay.2baf200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wepay.png
// module id = YWBY
// module chunks = 1